import React, {useContext} from "react";
import {Dropdown, Menu} from "antd";
import {AppContext} from "../../contexts/app-context";
import {LANG_ENUM} from "../../helpers/lang.helper";

const LANGUAGE_FLAGS = {
    [LANG_ENUM.RU]: "/img/svg/flags/ru.svg",
    [LANG_ENUM.EN]: "/img/svg/flags/en.svg",
    [LANG_ENUM.CN]: "/img/svg/flags/cn.svg",
};

export default function LanguageSwitcher() {
    const appContext = useContext(AppContext);

    const currentLanguageKey = (
        Object.keys(LANG_ENUM).find(
            (key) => LANG_ENUM[key] === appContext.lang.lang
        ) || "RU"
    );

    const languageMenu = (
        <Menu
            className="header-dropdown-menu header__language-menu"
            selectedKeys={[currentLanguageKey]}
        >
            {Object.keys(LANG_ENUM).map((key) => {
                const language = LANG_ENUM[key];

                return (
                    <Menu.Item
                        key={key}
                        onClick={() => appContext.setLang(language)}
                    >
                        <span className="header__lang-option">
                            <img
                                className="header__lang-flag"
                                src={LANGUAGE_FLAGS[language]}
                                alt=""
                                aria-hidden="true"
                            />

                            <span>{key}</span>
                        </span>
                    </Menu.Item>
                );
            })}
        </Menu>
    );

    return (
        <div className="header__lang">
            <Dropdown
                overlay={languageMenu}
                trigger={["click"]}
                placement="bottomRight"
            >
                <button
                    className="ant-dropdown-link header__utility-control header__language-toggle"
                    type="button"
                    aria-haspopup="menu"
                >
                    <span className="header__lang-value">
                        <img
                            className="header__lang-flag"
                            src={LANGUAGE_FLAGS[appContext.lang.lang]}
                            alt=""
                            aria-hidden="true"
                        />

                        <span>{currentLanguageKey}</span>
                    </span>

                    <span
                        className="header__lang-arrow"
                        aria-hidden="true"
                    >
                        <svg
                            viewBox="0 0 12 8"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1 1.25L6 6.25L11 1.25"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </span>
                </button>
            </Dropdown>
        </div>
    );
}